import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img01 from "../../images/services/rd/Emerging-Technologies.webp";
import Img02 from "../../images/services/rd/Product-Research.webp";
import Img03 from "../../images/services/rd/Innovation-Lab.webp";
import Img04 from "../../images/services/rd/Proof-of-Concept.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Servicespartner(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Future">
                            <h2>Fostering Ideas Of The Future For A Better World Through R&D</h2>
                            <h5
                            className="strong">Why partner with TekRevol for research and development services?</h5>

                        </div>

                        <p>With years of experience building world-class digital solutions and working with 500+ small, medium, and large-scale businesses, including Fortune 500 companies, TekRevol is a suitable choice for research and development solutions. For years, we have delivered on our promise of upholding top-quality digital services, and when it comes to research and development, this doesn’t change. Our processes are built to provide maximum convenience to clients around the globe and enable them to withstand modern-day challenges by leveraging our expertise. Our dedicated research and development team has a diverse background which allows us to accept and complete all kinds of projects.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-5 offset-lg-1">
                        <Row>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img01}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Emerging Technologies</p>
                                </div>
                                <div className="set_of_images hover01 mt-4">
                                    <LazyLoadImage
                                        src={Img03}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Innovation Lab</p>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-4 mt-md-0">
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img02}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Product Research</p>
                                </div>
                                <div className="set_of_images hover01  mt-4">
                                    <LazyLoadImage
                                        src={Img04}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Proof of Concept</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Servicespartner;